<template>
    <section class="section section-lg section-shaped overflow-hidden my-0">
        <div class="shape shape-style-1 bg-gradient-warning shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0 pb-lg">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-5 mb-5 mb-lg-0">
                    <h1 class="text-white font-weight-light">Recents Works</h1>
                    <p class="lead text-white mt-4"> Kami sudah mengerjakan berbagai project sesuai dengan kebutuhan client. Berikut project terbaru kami. </p>
                    <a href="/portfolio"
                       class="btn btn-white mt-4">See all our works</a>
                </div>
                <div class="col-lg-6 mb-lg-auto">
                    <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <!-- Text slides with image -->
                            <b-carousel-slide img-src="img/portfolio/project_1.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/project_2.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/project_3.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/project_4.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/project_5.jpg"></b-carousel-slide>

                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
</style>
